export const EXPORT_MESSAGE_ARCHIVE_REQUEST = 'gatewayDetails/EXPORT_MESSAGE_ARCHIVE_REQUEST';
export const EXPORT_MESSAGE_ARCHIVE = 'gatewayDetails/EXPORT_MESSAGE_ARCHIVE';

export const MAX_DAYS_RANGE = 90;
export const PRESELECTED_DAYS = 7;
export const MAX_DAYS_SELECTION_RANGE = 7;

export const captureFormats = {
    NETA21: 'NETA21',
    IOT: 'IoT',
    SmartSensor: 'SmartSensor',
    Generic: 'Generic',
    CASSIA: 'SmartSensor',
    ARUBA: 'SmartSensor',
    MACHSENSER: 'SmartSensor'
};
